export const KizeoFormsIcon = (props) => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    {...props}
  >
    <g>
      <path
        fill="#55c96b"
        d="m10.21 0.82l1.51-0.49c0.23-0.08 0.48 0.05 0.56 0.29l0.49 1.51c0.08 0.23-0.05 0.48-0.29 0.56l-1.51 0.49c-0.23 0.08-0.48-0.05-0.56-0.29l-0.49-1.51c-0.08-0.23 0.05-0.48 0.29-0.56z"
      />
      <path
        fill="#55c96b"
        d="m8.43 10.76h-2.17c-0.25 0-0.45-0.2-0.45-0.45v-1.58c0-0.25 0.2-0.45 0.45-0.45h0.69l-1.75-5.37c-0.07-0.23 0.05-0.48 0.29-0.56l1.51-0.49c0.23-0.07 0.48 0.05 0.56 0.29l2.2 6.77q0.06 0.22-0.06 0.4l-0.91 1.26q-0.14 0.18-0.36 0.18z"
      />
      <path
        fill="#55c96b"
        d="m1.3 8.28h1.59c0.25 0 0.45 0.2 0.45 0.45v1.59c0 0.24-0.2 0.44-0.45 0.44h-1.59c-0.24 0-0.44-0.2-0.44-0.44v-1.59c0-0.25 0.2-0.45 0.44-0.45z"
      />
      <path
        fill="#55c96b"
        d="m8.53 17.43l-1.51-0.49c-0.23-0.08-0.36-0.33-0.29-0.56l0.22-0.66h-5.65c-0.24 0-0.44-0.2-0.44-0.45v-1.58c0-0.25 0.2-0.45 0.44-0.45h7.13q0.22 0 0.36 0.18l0.91 1.26q0.13 0.18 0.06 0.4l-0.67 2.06c-0.07 0.24-0.33 0.36-0.56 0.29z"
      />
      <path
        fill="#55c96b"
        d="m5.2 21.09l0.5-1.52c0.07-0.23 0.32-0.36 0.56-0.28l1.51 0.49c0.23 0.08 0.36 0.33 0.28 0.56l-0.49 1.51c-0.07 0.24-0.33 0.36-0.56 0.29l-1.51-0.49c-0.23-0.08-0.36-0.33-0.29-0.56z"
      />
      <path
        fill="#55c96b"
        d="m11.71 23.67l-1.51-0.49c-0.23-0.08-0.36-0.33-0.28-0.56l2.2-6.78q0.07-0.21 0.29-0.28l1.47-0.48q0.21-0.07 0.4 0.06l1.75 1.28c0.2 0.14 0.25 0.42 0.1 0.62l-0.93 1.28c-0.15 0.2-0.42 0.25-0.62 0.1l-0.56-0.41-1.75 5.37c-0.07 0.24-0.32 0.37-0.56 0.29z"
      />
      <path
        fill="#55c96b"
        d="m17.2 19.78l0.94-1.29c0.14-0.2 0.42-0.24 0.62-0.1l1.29 0.94c0.19 0.14 0.24 0.42 0.09 0.62l-0.93 1.29c-0.14 0.19-0.42 0.24-0.62 0.09l-1.29-0.93c-0.2-0.14-0.24-0.42-0.1-0.62z"
      />
      <path
        fill="#55c96b"
        d="m13.88 8.92l-1.47-0.48q-0.21-0.07-0.29-0.28l-0.67-2.07c-0.08-0.23 0.05-0.48 0.29-0.56l1.51-0.49c0.23-0.08 0.48 0.05 0.56 0.29l0.21 0.66 4.57-3.32c0.2-0.15 0.48-0.1 0.62 0.1l0.93 1.28c0.15 0.2 0.1 0.48-0.09 0.62l-5.77 4.19q-0.18 0.13-0.4 0.06z"
      />
      <path
        fill="#55c96b"
        d="m21.5 17.32l-5.76-4.18q-0.18-0.14-0.19-0.36v-1.56q0.01-0.22 0.19-0.36l1.75-1.27c0.2-0.15 0.48-0.1 0.63 0.1l0.93 1.28c0.14 0.2 0.1 0.48-0.1 0.62l-0.56 0.41 4.57 3.32c0.2 0.14 0.24 0.42 0.1 0.62l-0.94 1.28c-0.14 0.2-0.42 0.25-0.62 0.1q0 0 0 0z"
      />
      <path
        fill="#55c96b"
        d="m20.22 7.61l1.28-0.93c0.2-0.15 0.48-0.1 0.62 0.1l0.94 1.28c0.14 0.2 0.1 0.48-0.1 0.62l-1.29 0.94c-0.2 0.14-0.47 0.1-0.62-0.1l-0.93-1.29c-0.15-0.2-0.1-0.47 0.1-0.62z"
      />
    </g>
  </svg>
);
